import { useState } from 'preact/hooks';
import { ServiceList } from './ServiceList';

export interface Service {
  id: string;
  name: string;
  container_name: string | null;
  compose_dir: string | null;
  group_name: string | null;
  sort_order: number;
  is_restartable: number;
}

export interface Server {
  id: string;
  name: string;
  hostname: string;
  internal_ip: string | null;
  sort_order: number;
  services: Service[];
}

interface ServerCardProps {
  server: Server;
  onServicesChange: (serverId: string, services: Service[]) => void;
  onAddService: (serverId: string) => void;
}

export function ServerCard({ server, onServicesChange, onAddService }: ServerCardProps) {
  const [expanded, setExpanded] = useState(true);

  return (
    <div class="server-card">
      <div class="server-header" onClick={() => setExpanded(!expanded)}>
        <div class="server-info">
          <h2 class="server-name">{server.name}</h2>
          <span class="server-hostname">{server.hostname}</span>
        </div>
        <span class="expand-icon">{expanded ? '▼' : '▶'}</span>
      </div>

      {expanded && (
        <div class="server-body">
          <ServiceList
            services={server.services}
            onChange={(services) => onServicesChange(server.id, services)}
          />
          <button
            class="btn btn-secondary btn-add-service"
            onClick={() => onAddService(server.id)}
          >
            + Service hinzufügen
          </button>
        </div>
      )}
    </div>
  );
}
